/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    Artifi: any; // Replace 'any' with the specific type
  }
}
import React, { useEffect } from "react";
import { Artifisettings } from "api/IProduct";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCustomProductDetails } from "store/slices/product.slice";
import { useAppSelector } from "hooks/reduxHooks";
import { notificationController } from "components/Common/Notification/Notification";
import { saveArtifiDetails } from "api/services/product.api";
import { setUuid } from "store/slices/uuid.slice";
import uuid from "react-uuid";
import { checkIsDesignIdExists } from "api/services/getLookupConfiguration.api";

interface Props {
  artifConfigurations: Artifisettings | undefined;
  setShowComponent: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRecord?: any;
  EditMode?: boolean;
  ReorderMode?: boolean;
  lookupMode?: boolean;
  configurationId?: any;
  getProductList?: (groupName: string, isCreatedCustomProduct: boolean) => void;
}

interface selectedProductReduxType {
  ConfigurationName: string | null;
  designName: string;
  CreatedBy: number;
  CreatedDate: string;
  Custom1: null;
  Custom2: null;
  Custom3: null;
  Custom4: null;
  Custom5: null;
  DesignId: string;
  designId: number;
  Name: string;
  GroupName: string;
  ImageLargePath: string;
  ImageMediumPath: string;
  ImageSmallPath: string;
  ImageSmallThumbnailPath: null;
  ImageThumbNailPath: string;
  ModifiedBy: number;
  ModifiedDate: string;
  ProductCustomizationJson: string;
  ProductId: number;
  ProductName: string;
  SKU: string;
  UserId: number;
  ZnodeMyLockerProductCustomizationDetailsId: number;
}

//eslint-disable-next-line
const ArtifiIntegration: React.FC<Props> = ({
  artifConfigurations,
  setShowComponent,
  selectedRecord,
  EditMode,
  ReorderMode,
  configurationId,
  getProductList,
  lookupMode,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useAppSelector((state: any) => state.user.user);
  const portalId = useAppSelector((state: any) => state.landingPage.portalId);
  const uId = uuid();
  const selectedProductRedux: selectedProductReduxType = useAppSelector(
    (state: any) => state.product.selectedProduct
  )!;

  const lookup: any = useAppSelector((state: any) => state?.lookupSlice?.initialState?.fromLookup);

  useEffect(() => {
    const handleBackButton = (event: any) => {
      event.preventDefault();
      setShowComponent(false);
    };

    if (!lookup) {
      navigate("/");
    }

    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  const handleUpdateArtifi = async (addToCartData: selectedProductReduxType) => {
    const reqBody = {
      ZnodeMyLockerProductCustomizationDetailsId:
        selectedProductRedux?.ZnodeMyLockerProductCustomizationDetailsId,
      productId: selectedProductRedux?.ProductId,
      productName: selectedProductRedux?.ProductName || selectedProductRedux?.Name,
      sku: selectedProductRedux?.SKU,
      configurationName: addToCartData?.designName,
      groupName: selectedProductRedux.GroupName,
      userId: userDetails?.id,
      designId: addToCartData?.designId,
      productCustomizationJson: JSON.stringify(addToCartData),
      CreatedBy: userDetails?.id,
      DesignType: "Artifi",
    };

    saveArtifiDetails(reqBody)
      .then(() => {
        localStorage.removeItem("selectedProduct");
        notificationController.success({
          message: "Design saved successfully",
        });
        navigate("/");
        if (getProductList) getProductList("", true);
        setShowComponent(false);
      })
      .catch((err) => {
        notificationController.error({
          message: "Something went wrong !",
        });
        throw err;
      });
  };

  useEffect(() => {
    dispatch(setUuid(uId as any));
    const integrationValues = {
      productCode: selectedProductRedux?.SKU || selectedRecord?.SKU,
      websiteId: artifConfigurations?.WebsiteCode,
      webApiclientKey: artifConfigurations?.WebApiclientKey,
      userId: userDetails?.id || uId,
      divId: "artifi-container",
      isGuest: !userDetails?.id ? true : false, //send false if userId is not 0
      width: "100%",
      height: "100%",
      ...(EditMode && { DesignId: selectedProductRedux?.DesignId || selectedRecord?.DesignId }),
      extraQueryString: `ClientCode=${portalId}&Role=myLocker`,
      ...(ReorderMode && { DesignId: configurationId, appMode: "reorder" }),
      ...(lookupMode && { DesignId: configurationId, appMode: "lookup" }),
    };
    // Initialize Artifi
    window.Artifi.Initialize(integrationValues);

    //eslint-disable-next-line
    const receiveArtifiMessage = (event: MessageEvent) => {
      // Check if event.data is a string and try to parse it as JSON
      let receivedData;
      if (typeof event.data === "string") {
        try {
          receivedData = JSON.parse(event.data);
        } catch (error) {
          return;
        }
      } else if (typeof event.data === "object" && event.data !== null) {
        // If event.data is already an object, use it directly
        receivedData = event.data;
      } else {
        return;
      }
      // Add event listener to receive messages from Artifi
      switch (receivedData.action) {
        case "artifi-add-to-cart-and-exit":
          //eslint-disable-next-line no-case-declarations
          const addToCartData = JSON.parse(receivedData?.data);

          checkIsDesignIdExists(addToCartData?.designId).then((resp) => {
            if (resp?.data?.IsSuccess) {
              navigate("/");
            }
          });
          //Here we can call the saveDYODetails api
          dispatch(setCustomProductDetails(addToCartData));
          if (!userDetails?.id) {
            navigate("/login?redirect_url=/save-configuration");
          } else {
            !EditMode && navigate("/save-configuration");
            EditMode && handleUpdateArtifi(addToCartData);
          }
          //we have to call the Update api
          break;
        case "artifi-exit":
          setShowComponent(false);
          break;
      }
    };

    if (window.addEventListener) {
      window.addEventListener("message", receiveArtifiMessage, false);
    } else {
      (window as any).attachEvent("onmessage", receiveArtifiMessage);
    }
    // Cleanup function
    return () => {
      if (window.removeEventListener) {
        window.removeEventListener("message", receiveArtifiMessage, false);
      } else {
        (window as any).detachEvent("onmessage", receiveArtifiMessage);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artifConfigurations]);

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: 9,
        // paddingTop: "30px",
        background: "white",
      }}
    >
      <div
        id="artifi-container"
        style={{
          width: "100%",
          height: "100%",
        }}
      ></div>
    </div>
  );
};

export default ArtifiIntegration;
